<template>
    <div :class="['customer-info-box', 'drei_60-border-1', border, 'shadow']">
        <div :class="['customer-info-box__icon', background]">
            <v-icon class="drei_60-white-text">{{ icon }}</v-icon>
        </div>
        <div>
            <div class="text-uppercase customer-info-box__title">{{ title }}</div>
            <div
                class="font-weight-bold customer-info-box__text"
                v-for="(t, index) in text"
                :key="`info-box-text-${index}`"
            >
                {{ t }}
            </div>
            <div class="customer-info-box__target">
                <v-btn small class="drei_60-btn" v-if="!!target" :to="target">
                    {{ targetTitle }}
                    <v-icon small>mdi-arrow-right</v-icon>
                </v-btn>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'InfoBox',
    props: [
        'icon',
        'title',
        'text',
        'color',
        'target',
        'targetTitle',
    ],
    computed: {
        background() {
            const { color } = this.$props;
            return `drei_60-${color}`;
        },
        border() {
            const { color } = this.$props;
            return `drei_60-${color}-border`;
        },
    },
};
</script>

<style scoped lang="scss">
    .customer-info-box {
        display: flex;
    }
    .customer-info-box__title, .customer-info-box__text {
        flex: none;
    }
    .customer-info-box__target {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        align-content: baseline;
    }
    .customer-info-box__target .v-btn {
        margin: 0;
        padding: 0;
    }
    .customer-info-box__icon {
        flex: none;
        padding: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .customer-info-box__icon + div {
        flex: 1;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }
</style>
